import * as React from 'react';
import {
  Button,
  GDSHeadingLevel,
  HeadingText,
  ImageMessage,
  ParagraphText,
  StackLayout,
} from '@leagueplatform/genesis-core';

export interface MessageStateProps {
  image?: string;
  imageAlt?: string;
  heading?: string;
  headingLevel?: GDSHeadingLevel;
  description?: string;
  buttonLabel?: string;
  onButtonClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const MessageState = ({
  image = '',
  imageAlt = '',
  heading,
  headingLevel = '2',
  description,
  buttonLabel,
  onButtonClick,
}: MessageStateProps) => (
  <StackLayout
    horizontalAlignment="center"
    verticalAlignment="center"
    css={{
      flexGrow: 1,
      textAlign: 'center',
      padding: '$two',
    }}
  >
    <ImageMessage
      image={image}
      imageAlt={imageAlt}
      imageWidth={140}
      imageHeight={140}
    >
      {(heading || description) && (
        <StackLayout horizontalAlignment="center" spacing="$half">
          {heading && (
            <HeadingText level={headingLevel} size="lg">
              {heading}
            </HeadingText>
          )}
          {description && <ParagraphText>{description}</ParagraphText>}
        </StackLayout>
      )}
      {buttonLabel && onButtonClick && (
        <Button
          onClick={onButtonClick}
          priority="primary"
          css={{ marginTop: '$oneAndHalf' }}
        >
          {buttonLabel}
        </Button>
      )}
    </ImageMessage>
  </StackLayout>
);
